'use strict';

module.exports = Backbone.Model.extend({
    accountBlocked: {
        data: '',
        action: 'recoverpassword',
    },
});
